import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import "./Sidebar.scss";
import "rc-tooltip/assets/bootstrap.css";
import "../../../node_modules/rc-slider/assets/index.css";
import { AppContext } from "../../context";
import Poi from "../../page/Poi";
import { ReactComponent as Back } from "../../assets/icons/back.svg";
import { SCREEN_SIZES } from "../../config/constants";
import { loadCurrentData } from "../../store/actions";
import { useDispatch } from "react-redux";

const Sidebar = ({ setAppState, hoveredArea, isInfoDataExist, handleClearSelectedAreas, setHoveredArea }) => {
  var isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
  const state = useContext(AppContext);
  const dispatch = useDispatch();
  const {
    activeFloor,
    isMenuOpen,
    secondPage
  } = state;

  useEffect(() => {
    if (isMenuOpen) {
      document.getElementById("menu-button").checked = true;
    }
  }, [isMenuOpen]);

  const handlePoiClose = (secondPage) => {
    setAppState({ prop: "secondPage", value: { ...secondPage, filterOpen: false, imageOpen: false } });
  };
  const removeInfo = () =>{
   if (window.innerWidth > SCREEN_SIZES.tablet[1]){
      setHoveredArea(null);
      dispatch(loadCurrentData());
    }
  }
  return (
    <>
      <div
        className="sidebar-header__toggle">
        <input type="checkbox" id="menu-button" />
        <label htmlFor="menu-button" className="icon" onClick={() => {
          setAppState({ prop: "isMenuOpen", value: !isMenuOpen });
          handleClearSelectedAreas();
          handlePoiClose();
          dispatch(loadCurrentData());
        }}>
          <div className="menu-button"></div>
        </label>
      </div>
      <nav id="sidebar" className={(isMenuOpen ? "active " : "") + "sidebar"} onClick={removeInfo} onTouchStart={removeInfo}>
        {window.innerWidth < SCREEN_SIZES.tablet[1] && secondPage.filterOpen && secondPage.id ?
          <>
            <div className={"back"} onClick={() => {
              handleClearSelectedAreas();
              handlePoiClose();
              dispatch(loadCurrentData());
            }
            }>
              <Back />
            </div>
            <Poi id={secondPage.id} setAppState={setAppState} />
          </>
          :
          <>
            <img className={"logo mb-3"} src={`./${process.env.PUBLIC_URL}/logo.png`} alt=""
                 style={{ margin: (!isMobile && window.innerWidth < SCREEN_SIZES.tablet[1]) ? "43px auto 0" : "10px auto 0" }} />
            <div className="menu">
              <div className={`btn-group btn-group${activeFloor === "floor-all" ? "-active" : ""}`}>
                <Button
                  variant="link"
                  className={activeFloor === "floor-all" && "active"}
                  onClick={() =>
                    setAppState({ prop: "activeFloor", value: "floor-all" })
                  }
                >
                  Roof level
                </Button>
              </div>

              <div
                className={`btn-group btn-group-sep${activeFloor === "floor-5" || activeFloor === "floor-5-empty" ? "-active" : ""}`}>
                <Button
                  style={{ width: "60%", float: "left" }}
                  variant="link"
                  onClick={() =>
                    setAppState({ prop: "activeFloor", value: "floor-5" })
                  }
                >
                  Fifth floor
                </Button>
                <Button
                  style={{ width: "40%", float: "right" }}
                  className={`btn-group occupy ${activeFloor === "floor-5-empty" ? "active-floor" : ""}`}
                  variant="link"
                  onClick={() =>
                    setAppState({
                      prop: "activeFloor",
                      value: "floor-5-empty"
                    })
                  }
                >
                  occupy
                </Button>
              </div>

              <div className={`btn-group btn-group${activeFloor === "floor-4" ? "-active" : ""}`}>

                <Button
                  variant="link"
                  onClick={() =>
                    setAppState({ prop: "activeFloor", value: "floor-4" })
                  }
                >
                  Fourth floor
                </Button>
              </div>
              <div className={`btn-group btn-group${activeFloor === "floor-3" ? "-active" : ""}`}>
                <Button
                  variant="link"
                  onClick={() =>
                    setAppState({ prop: "activeFloor", value: "floor-3" })
                  }
                >
                  Third floor
                </Button>
              </div>
              <div className={`btn-group btn-group${activeFloor === "floor-2" ? "-active" : ""}`}>
                <Button
                  variant="link"
                  onClick={() =>
                    setAppState({ prop: "activeFloor", value: "floor-2" })
                  }
                >
                  Second floor
                </Button>
              </div>
              <div className={`btn-group btn-group${activeFloor === "floor-1" ? "-active" : ""}`}>
                <Button
                  variant="link"
                  onClick={() => setAppState({ prop: "activeFloor", value: "floor-1" })}
                >
                  First floor
                </Button>
              </div>
              <div className={`btn-group btn-group${activeFloor === "floor-0" ? "-active" : ""}`}>
                <Button
                  variant="link"
                  onClick={() => setAppState({ prop: "activeFloor", value: "floor-0" })}
                >
                  Ground floor
                </Button>
              </div>
            </div>
          </>
        }
        {window.innerWidth > SCREEN_SIZES.tablet[1] && hoveredArea && isInfoDataExist && <div className="screen-opacity" />}
      </nav>
    </>
  );
};
Sidebar.propTypes =
  {
    roomTypes: PropTypes.array
  };

export default Sidebar;
